﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageLoading = exports.PageDashboard = exports.CmpVXControl = exports.CmpModalDialog = exports.CmpInfoTile = void 0;
const gs = require("@ivanlog/gs");
class CmpInfoTileControls {
    constructor(ctrls) {
        this._ctrls = ctrls;
        this.lHeader = this._ctrls.get('lHeader');
        this.lText = this._ctrls.get('lText');
        this.lDescription = this._ctrls.get('lDescription');
    }
}
class CmpInfoTile extends gs.ComponentGS {
    constructor() {
        super("cmpInfoTile", CmpInfoTileControls);
    }
}
exports.CmpInfoTile = CmpInfoTile;
class CmpModalDialogControls {
    constructor(ctrls) {
        this._ctrls = ctrls;
        this.container = this._ctrls.get('container');
        this.content = this._ctrls.get('content');
        this.header = this._ctrls.get('header');
        this.textTitle = this._ctrls.get('textTitle');
        this.btnClose = this._ctrls.get('btnClose');
        this.body = this._ctrls.get('body');
        this.footer = this._ctrls.get('footer');
        this.btnOk = this._ctrls.get('btnOk');
        this.btnNo = this._ctrls.get('btnNo');
        this.btnCancel = this._ctrls.get('btnCancel');
    }
}
class CmpModalDialog extends gs.ComponentGS {
    constructor() {
        super("cmpModalDialog", CmpModalDialogControls);
    }
}
exports.CmpModalDialog = CmpModalDialog;
class CmpVXControlControls {
    constructor(ctrls) {
        this._ctrls = ctrls;
        this.blockTiles = this._ctrls.get('blockTiles');
        this.btnAddToken = this._ctrls.get('btnAddToken');
        this.btnInfoToggle = this._ctrls.get('btnInfoToggle');
        this.linfoAPR = this._ctrls.get('linfoAPR');
        this.lInfoRatio = this._ctrls.get('lInfoRatio');
        this.lInfoValueVX = this._ctrls.get('lInfoValueVX');
        this.lInfoValuePLS = this._ctrls.get('lInfoValuePLS');
        this.blockSVInfoAdditional = this._ctrls.get('blockSVInfoAdditional');
        this.lInfoValidators = this._ctrls.get('lInfoValidators');
        this.lInfoValidatorsExiting = this._ctrls.get('lInfoValidatorsExiting');
        this.lInfoTotalStake = this._ctrls.get('lInfoTotalStake');
        this.lInfoBalance = this._ctrls.get('lInfoBalance');
        this.lInfoTotalWithdrawal = this._ctrls.get('lInfoTotalWithdrawal');
        this.lInfoVXAddress = this._ctrls.get('lInfoVXAddress');
        this.lInfoVPoolAddress = this._ctrls.get('lInfoVPoolAddress');
        this.blockVXTabs = this._ctrls.get('blockVXTabs');
        this.btnTabStake = this._ctrls.get('btnTabStake');
        this.btnTabUnstake = this._ctrls.get('btnTabUnstake');
        this.btnTabVXS = this._ctrls.get('btnTabVXS');
        this.blockConnectWallet = this._ctrls.get('blockConnectWallet');
        this.btnConnectWallet = this._ctrls.get('btnConnectWallet');
        this.blockWithdrawPLS = this._ctrls.get('blockWithdrawPLS');
        this.btnWithdrawPLS = this._ctrls.get('btnWithdrawPLS');
        this.blockWithdrawVX = this._ctrls.get('blockWithdrawVX');
        this.btnWithdrawVX = this._ctrls.get('btnWithdrawVX');
        this.tabStake = this._ctrls.get('tabStake');
        this.iStakeValuePLS = this._ctrls.get('iStakeValuePLS');
        this.rStakeValuePLS = this._ctrls.get('rStakeValuePLS');
        this.lTxStakeVX = this._ctrls.get('lTxStakeVX');
        this.blockTxStakeValidatorsGas = this._ctrls.get('blockTxStakeValidatorsGas');
        this.lTxStakeValidatorsGas = this._ctrls.get('lTxStakeValidatorsGas');
        this.btnStakeSubmit = this._ctrls.get('btnStakeSubmit');
        this.tabUnstake = this._ctrls.get('tabUnstake');
        this.iUnstakeValueUPLS = this._ctrls.get('iUnstakeValueUPLS');
        this.btnUnstakeMax = this._ctrls.get('btnUnstakeMax');
        this.rUnstakeValueUPLS = this._ctrls.get('rUnstakeValueUPLS');
        this.lTxUnstakeValue = this._ctrls.get('lTxUnstakeValue');
        this.btnUnstakeSubmit = this._ctrls.get('btnUnstakeSubmit');
        this.blockVXSTabs = this._ctrls.get('blockVXSTabs');
        this.btnTabVXSConfig = this._ctrls.get('btnTabVXSConfig');
        this.btnTabVXSBot = this._ctrls.get('btnTabVXSBot');
        this.btnTabVX = this._ctrls.get('btnTabVX');
        this.tabVXSConfig = this._ctrls.get('tabVXSConfig');
        this.iVXSConfig_uPLSInStake = this._ctrls.get('iVXSConfig_uPLSInStake');
        this.iVXSConfig_SendPLSIndex = this._ctrls.get('iVXSConfig_SendPLSIndex');
        this.iVXSConfig_SendPLSReceiver = this._ctrls.get('iVXSConfig_SendPLSReceiver');
        this.iVXSConfig_BnSIndex = this._ctrls.get('iVXSConfig_BnSIndex');
        this.lVXSConfig_Router = this._ctrls.get('lVXSConfig_Router');
        this.btnVXSConfig_RouterPulseXV1 = this._ctrls.get('btnVXSConfig_RouterPulseXV1');
        this.btnVXSConfig_RouterPulseXV2 = this._ctrls.get('btnVXSConfig_RouterPulseXV2');
        this.iVXSSConfig_SwapPath = this._ctrls.get('iVXSSConfig_SwapPath');
        this.iVXSConfig_SwapMinPLSAmount = this._ctrls.get('iVXSConfig_SwapMinPLSAmount');
        this.iVXSConfig_SwapMaxPLSAmount = this._ctrls.get('iVXSConfig_SwapMaxPLSAmount');
        this.iVXSSConfig_SendAddress = this._ctrls.get('iVXSSConfig_SendAddress');
        this.btnVXSConfig_isBurn = this._ctrls.get('btnVXSConfig_isBurn');
        this.lVXSConfigStats = this._ctrls.get('lVXSConfigStats');
        this.lVXSConfigStrategyAddress = this._ctrls.get('lVXSConfigStrategyAddress');
        this.lVXSConfigStrategyUPLS = this._ctrls.get('lVXSConfigStrategyUPLS');
        this.btnVXSConfigSubmit = this._ctrls.get('btnVXSConfigSubmit');
        this.btnVXSMigrationSubmit = this._ctrls.get('btnVXSMigrationSubmit');
        this.iVXSConfig_DepositUPLS = this._ctrls.get('iVXSConfig_DepositUPLS');
        this.btnVXSConfigDepositUPLS = this._ctrls.get('btnVXSConfigDepositUPLS');
        this.btnVXSConfigWithdrawUPLS = this._ctrls.get('btnVXSConfigWithdrawUPLS');
        this.btnVXSConfigWithdrawPLS = this._ctrls.get('btnVXSConfigWithdrawPLS');
        this.tabVXSExecutor = this._ctrls.get('tabVXSExecutor');
        this.iVXSBot_SwapMaxSlippageIndex = this._ctrls.get('iVXSBot_SwapMaxSlippageIndex');
        this.iVXSBot_SwapFrequencyHours = this._ctrls.get('iVXSBot_SwapFrequencyHours');
        this.iVXSBot_SplitFrequencyHours = this._ctrls.get('iVXSBot_SplitFrequencyHours');
        this.iVXSBot_SplitMinProfitAmount = this._ctrls.get('iVXSBot_SplitMinProfitAmount');
        this.iVXSBot_MaxGasAmount = this._ctrls.get('iVXSBot_MaxGasAmount');
        this.btnVXSBotSubmit = this._ctrls.get('btnVXSBotSubmit');
    }
}
class CmpVXControl extends gs.ComponentGS {
    constructor() {
        super("cmpVXControl", CmpVXControlControls);
    }
}
exports.CmpVXControl = CmpVXControl;
class PageDashboardControls {
    constructor(ctrls) {
        this._ctrls = ctrls;
        this.blocks = this._ctrls.get('blocks');
    }
}
class PageDashboard extends gs.ComponentGS {
    constructor() {
        super("pageDashboard", PageDashboardControls);
    }
}
exports.PageDashboard = PageDashboard;
class PageLoadingControls {
    constructor(ctrls) {
        this._ctrls = ctrls;
    }
}
class PageLoading extends gs.ComponentGS {
    constructor() {
        super("pageLoading", PageLoadingControls);
    }
}
exports.PageLoading = PageLoading;
//# sourceMappingURL=tmpls.js.map